import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchBlogPosts } from "../lib/api";

const Media = () => {
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    fetchBlogPosts()
      .then((posts) => {
        const picked = (posts || [])
          .filter((p) => p.show_on_homepage)
          .sort((a, b) => (a.homepage_order || 0) - (b.homepage_order || 0))
          .slice(0, 3);
        setFeatured(picked);
      })
      .catch(() => setFeatured([]));
  }, []);

  if (featured.length === 0) return null;

  return (
    <section className="bg-[var(--ri-cream-2)]">
      <div className="container-x pb-24 pt-24">
        <div className="flex items-end justify-between mb-8">
          <div>
            <p className="eyebrow mb-2">Journal</p>
            <h3 className="font-serif-display text-[28px] md:text-[36px]">Stories from Istanbul.</h3>
          </div>
          <Link to="/blog" className="link-underline text-[14px] text-[var(--ri-red)] hidden sm:inline">See all articles →</Link>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {featured.map((a) => (
            <Link key={a.slug} to={`/blog/${a.slug}`} className="group card block">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={a.image} alt={a.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <p className="eyebrow text-[var(--ri-muted)]">{a.label}</p>
                <h3 className="mt-2 font-serif-display text-[20px] leading-[1.15]">{a.title}</h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Media;
